<template>
  <transition name="ios-add-to-home-popup">
    <div
      v-show="showPopup"
      class="ios-add-to-home-popup__wrapper"
      @click="clickPopup">
      <div class="ios-add-to-home-popup__text">
        <img src="/img/actionIcon_100_WHITE.png">を押してホーム画面に追加。
      </div>
      <i class="bx bx-x bx-md ios-add-to-home-popup__close-icon" />
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    showPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    clickPopup() {
      this.$emit('clickPopup')
    }
  }
}
</script>

<style lang="scss" scoped>
.ios-add-to-home-popup__wrapper {
  background-color: $grey05;
  position: fixed;
  left: 10px;
  right: 10px;
  bottom: 10px;
  height: 4rem;
  border-radius: 5px;
  z-index: 220;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: whitesmoke;
}

.ios-add-to-home-popup__text {
  color: text-white;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ios-add-to-home-popup__text img {
  width: 20px;
}

.ios-add-to-home-popup__close-icon {
  color: white;
}

.ios-add-to-home-popup-enter-active,
.ios-add-to-home-popup-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.ios-add-to-home-popup-enter,
.ios-add-to-home-popup-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
</style>
